import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Checkbox, Notification } from 'wix-style-react'
import * as _ from 'lodash'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { displayError } from 'components/NotificationController'
import { setCustomFieldArray } from '../../../controllers/logic'
import emptyStateIcon from '../../../assets/empty_state_image_icon.png'
import { media, TEAL, HELVETICA } from '../../styles'
import { assetRemoved } from '../../../controllers/assets'
import { removeFromStorage, uploadToStorage, uploadToStorageVideo } from '../../../controllers/storage'
import { processImage,
         processVideo,
         VIDEO_FILETYPES,
         IMAGE_FILETYPES } from '../../../utils/uploadUtils'

import AssetCard from '../assetsManager/AssetCard'
import Droppable from 'components/editor/assetsManager/Droppable'
import UploadDisclimer from 'components/editor/assetsManager/UploadDisclimer'

const IMAGE_UPLOAD_HINT = 'Drag\'n\'drop images in JPEG, PNG or SVG frormats.'
const VIDEO_UPLOAD_HINT = 'Drag\'n\'drop videos in MP4 frormat.'

const MainContainer = styled.div`
  width: 100%;
  ${props => props.scrollable ? 'overflow-y: scroll;' : ''}
`
const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
`


const SubMenu = styled.div`
  display: flex;
  flex-direction: row;
  ${media.small`height: 45px;`}
  ${media.huge`height: 60px;`}
  &, & > div > label > div {
    ${media.small`font-size: 14px;`}
    ${media.huge`font-size: 16px;`}
  }
  align-items: center;
  width: 100%;
  padding: 0 17px;
  border-bottom: 1px solid #DFE5EB;
`
const UploadHint = styled.div`
  color: #32536A;
  flex: 1 0 200px;
  line-height: 120%;
`
const AssetsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  padding-top: 0.4em;

  & > div {
    outline: none;
  }
`
const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 5em;
`
const EmptyStateImage = styled.img`
  width: auto;
  ${media.small`height: 100px; margin: 15px 0px 35px 0px;`}
  ${media.huge`height: 150px; margin: 15px 0px 35px 0px;`}
`
const EmptyStateText = styled.div`
  color: ${TEAL};
  ${HELVETICA};
  opacity: 0.4;
  font-size: 120%;
`

class AssetsSelector extends Component {

  constructor (props) {
    super(props)
    this.state = {
      showAllAssets: false,
      showWarning: false,
      assets: this.getAssets(props, false)
    }
  }

  componentWillReceiveProps (nextProps) {
    const { showAllAssets } = this.state
    this.setState({
      assets: this.getAssets(nextProps, showAllAssets)
    })
  }

  renderWarning () {
    return (
      <Notification
        onClose={() => this.setState({showWarning: false})}
        show
        size='big'
        theme='warning'
        timeout={6000}
        type='local'
        zIndex={10000}
      >
        <Notification.TextLabel>
          Warning! Your image height should be more than width!
        </Notification.TextLabel>
        <Notification.CloseButton />
      </Notification>
    )
  }

  select (data) {
    const { app, dispatch, path, currentValue } = this.props
    // console.log('select', data)
    if (_.isArray(currentValue)) {
      // unselect the asset
      const newCurrentValue = _.clone(currentValue)
      if (currentValue.indexOf(data) >= 0) {
        _.remove(newCurrentValue, elt => elt === data)
      } else {
        newCurrentValue.push(data)
      }
      dispatch(setCustomFieldArray(app.id, path, newCurrentValue))
    } else {
      if (data === currentValue || (data.url && data.url === currentValue.url)) {
        dispatch(setCustomFieldArray(app.id, path, null))
      } else {
        dispatch(setCustomFieldArray(app.id, path, data))
      }
    }
  }

  onShowAllAssets = (e) => {
    const checked = e.target.checked
    this.setState({
      showAllAssets: checked,
      assets: this.getAssets(this.props, checked)
    })
  }

  onAssetClick = (asset) => {
    return () => {
      const { isVideo } = this.props
      if (isVideo) {
        const data = {
          url: asset.url,
          thumbUrl: asset.thumb.url
        }
        this.select(data)
      } else {
        this.select(asset.url)
      }

    }
  }

  isSelected = (url) => {
    const { currentValue } = this.props
    // console.log('check is selected, current value', currentValue)
    if (_.isString(currentValue)) {
      return url === currentValue
    } else if (_.isArray(currentValue)) {
      return currentValue.indexOf(url) >= 0
    } else if (_.isObject(currentValue)) {
      return url === currentValue.url
    } else {
      return false
    }
  }

  appIdByAsset = (asset) => {
    const { apps } = this.props
    let appId
    for (const id in apps) {
      if (_.has(apps, [id, 'assets', asset.id])) appId = id
    }
    return appId
  }

  onDelete = (asset) => {
    // console.log('onDelete', asset)
    const { dispatch } = this.props
    const appId = this.appIdByAsset(asset)
    if (appId) {
      if (_.has(asset, ['thumb', 'id'])) {
        dispatch(removeFromStorage(appId, asset.thumb.id))
      }
      dispatch(removeFromStorage(appId, asset.id))
      dispatch(assetRemoved(asset))
    }
  }

  renderAsset = (asset, id) => {
    console.log('render asser', asset, id)
    const { isVideo } = this.props
    if ((!isVideo && asset.type !== 'video') || (isVideo && asset.type === 'video')) {
      const appId = this.appIdByAsset(asset)
      if (appId) {
        return (
          <AssetCard
            key={id}
            appId={this.appIdByAsset(asset)}
            asset={asset}
            onSet={this.onAssetClick(asset)}
            isSelected={this.isSelected(asset.url)}
            onDelete={this.onDelete}
          />
        )
      }
    }
  }

  getAssets = (props, showAll) => {
    const { assets, apps, app, isVideo } = props
    let assetsData = _.assign(assets, app.assets)
    if (showAll) {
      assetsData = {}
      for (const appId in apps) {
        const app = apps[appId]
        if (_.has(app, 'assets')) {
          assetsData = _.assign(assetsData, app.assets)
        }
      }
    }
    const isValid = asset => {
      return (!isVideo && asset.type !== 'video') || (isVideo && asset.type === 'video')
    }
    const fileredAsssets = _.filter(assetsData, isValid)
    // console.log('getAssets', assetsData)
    return _.sortBy(fileredAsssets, ['uploadedAt'], ['desc'])
  }

  renderEmptyState () {
    let fileTypeName = 'an image'
    if (this.props.isVideo) fileTypeName = 'a video file'
    return (
      <EmptyStateContainer>
        <EmptyStateImage src={emptyStateIcon} />
        <EmptyStateText>{`Upload ${fileTypeName} to get started`}</EmptyStateText>
      </EmptyStateContainer>
    )
  }

  renderAllAssets (assets) {
    return (
      <AssetsContainer>
        {_.map(assets, this.renderAsset)}
      </AssetsContainer>
    )
  }

  onDropAccepted = (file) => {
    // console.log('onDropAccepted', file)
    const { dispatch, app } = this.props

    if (this.props.isVideo) {
      processVideo(file).then(({videoFile, imageFile}) => {
        dispatch(uploadToStorageVideo(app.id, videoFile, imageFile))
      }).catch(reason => {
        displayError(`${file.name} file upload failed.`)
      })
    } else {
      processImage(file).then((fileToUpload) => {
        if (fileToUpload.wrongAR) {
          this.setState({showWarning: true})
        }
        dispatch(uploadToStorage(app.id, fileToUpload))
      }).catch(reason => {
        displayError(`${file.name} file upload failed.`)
      })
    }
  }

  onDropRejected = (file) => {
    displayError(`${file.name} has unaccepatable extension of file.`)
  }

  render () {
    const { isVideo } = this.props
    const { assets } = this.state
    console.log('assets', assets)
    const filetypes = isVideo ? VIDEO_FILETYPES : IMAGE_FILETYPES
    return (
      <Droppable
        dragOverlay={<UploadDisclimer />}
        onDropAccepted={this.onDropAccepted}
        onDropRejected={this.onDropRejected}
        filetypes={filetypes}
        needsCrop={!isVideo}
      >
        {this.state.showWarning && this.renderWarning()}
        <MainContainer scrollable={assets.length > 0}>
          <DataContainer>
            <SubMenu>
              <UploadHint>
                {isVideo ? VIDEO_UPLOAD_HINT : IMAGE_UPLOAD_HINT}
              </UploadHint>
              <Checkbox
                onChange={this.onShowAllAssets}
                checked={this.state.showAllAssets}
              >
                Assets from All Projects
              </Checkbox>
            </SubMenu>
            <AssetsContainer>
              {(assets.length > 0) ? this.renderAllAssets(assets) : this.renderEmptyState()}
            </AssetsContainer>
          </DataContainer>
        </MainContainer>
      </Droppable>
    )
  }
}

AssetsSelector.defaultProps = {
  isVideo: false,
  currentValue: {},
  assets: {}
}

AssetsSelector.propTypes = {
  isVideo: PropTypes.bool,
  currentValue: PropTypes.oneOfType([ PropTypes.object, PropTypes.string, PropTypes.array ]),
  assets: PropTypes.object,
  path: PropTypes.array.isRequired,
  apps: PropTypes.object.isRequired,
  app: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  apps: state.apps
})

export default connect(mapStateToProps)(AssetsSelector)



// WEBPACK FOOTER //
// ./src/components/editor/popovers/AssetsSelector.js